import { render, staticRenderFns } from "./SoilType.html?vue&type=template&id=d2989e64&scoped=true&external"
import script from "./SoilType.vue?vue&type=script&lang=js"
export * from "./SoilType.vue?vue&type=script&lang=js"
import style0 from "./SoilType.scss?vue&type=style&index=0&id=d2989e64&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2989e64",
  null
  
)

export default component.exports